"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9497],{

/***/ 85789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15437);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  position: relative;\n  width: 40px;\n  height: 40px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  animation: ",
        ' 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  transform-origin: 30px 30px;\n  &:after {\n    content: " ";\n    display: block;\n    position: absolute;\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    margin: -4px 0 0 -4px;\n  }\n'
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var ldsRollerAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .keyframes */ .F4)(_templateObject());
var LdsRollerContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e2fabba3-0"
})(_templateObject1());
var LdsRollerDiv = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e2fabba3-1"
})(_templateObject2(), ldsRollerAnimation);
var Loader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(LdsRollerContainer, {
        className: "lds-roller",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LdsRollerDiv, {
                className: "after:bg-main",
                style: {
                    animationDelay: "-0.036s"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LdsRollerDiv, {
                className: "after:bg-main",
                style: {
                    animationDelay: "-0.072s"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LdsRollerDiv, {
                className: "after:bg-main",
                style: {
                    animationDelay: "-0.108s"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LdsRollerDiv, {
                className: "after:bg-main",
                style: {
                    animationDelay: "-0.144s"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LdsRollerDiv, {
                className: "after:bg-main",
                style: {
                    animationDelay: "-0.18s"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LdsRollerDiv, {
                className: "after:bg-main",
                style: {
                    animationDelay: "-0.216s"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LdsRollerDiv, {
                className: "after:bg-main",
                style: {
                    animationDelay: "-0.252s"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LdsRollerDiv, {
                className: "after:bg-main",
                style: {
                    animationDelay: "-0.288s"
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Loader);


/***/ }),

/***/ 75166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ twinSlider_TwinBots; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(40993);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./lib/config.js
var config = __webpack_require__(29159);
// EXTERNAL MODULE: ./components/elements/Loader.jsx
var Loader = __webpack_require__(85789);
// EXTERNAL MODULE: ./components/shared/Container.jsx
var Container = __webpack_require__(21707);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/shared/styles/TextContainer.js
var TextContainer = __webpack_require__(16388);
// EXTERNAL MODULE: ./utility/endpoints.js
var endpoints = __webpack_require__(49530);
// EXTERNAL MODULE: ./lib/store/useSasStore.js
var useSasStore = __webpack_require__(91345);
;// CONCATENATED MODULE: ./components/layout/home/twinSlider/TwinCard.jsx







var Image = function(param) {
    var url = param.url, alt = param.alt;
    var ref = (0,react.useState)(false), isError = ref[0], setError = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
            className: "relative rounded-full overflow-hidden h-28 w-28 mx-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                onError: function() {
                    setError(true);
                },
                // fill
                layout: "fill",
                objectFit: "cover",
                sizes: "100px",
                src: isError ? "/imagess/no-user-profile.webp" : url || "/imagess/no-user-profile.webp",
                className: "rounded-full mx-auto h-full w-full object-cover",
                alt: alt
            })
        })
    });
};
var TwinCard = function(param) {
    var twin = param.twin, showCloneBtn = param.showCloneBtn;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var ref13 = (0,react.useState)(false), isError = ref13[0], setError = ref13[1];
    var sasToken = (0,useSasStore/* useSas */.k)().sasToken;
    return (twin === null || twin === void 0 ? void 0 : (ref = twin._source) === null || ref === void 0 ? void 0 : ref.employeeTwinName.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: " bg-accent rounded-3xl h-[440px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/Employeetwinsdetail?empTwinId=".concat(twin === null || twin === void 0 ? void 0 : (ref1 = twin._source) === null || ref1 === void 0 ? void 0 : ref1.employeeTwinID, "&name=").concat(twin === null || twin === void 0 ? void 0 : (ref2 = twin._source) === null || ref2 === void 0 ? void 0 : ref2.employeeTwinName, "&leadPlatform=").concat(twin === null || twin === void 0 ? void 0 : (ref3 = twin._source) === null || ref3 === void 0 ? void 0 : ref3.leadPlatform),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "block h-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-center flex flex-col justify-between h-full p-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                        url: "".concat(twin === null || twin === void 0 ? void 0 : (ref4 = twin._source) === null || ref4 === void 0 ? void 0 : ref4.uploadPhoto, "?").concat(sasToken),
                                        alt: twin === null || twin === void 0 ? void 0 : (ref5 = twin._source) === null || ref5 === void 0 ? void 0 : ref5.employeeTwinName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "font-medium uppercase mt-4",
                                        style: {
                                            color: "#551A8B"
                                        },
                                        children: twin === null || twin === void 0 ? void 0 : (ref6 = twin._source) === null || ref6 === void 0 ? void 0 : ref6.employeeTwinName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: "text-main capitalize font-medium text-sm",
                                        children: twin === null || twin === void 0 ? void 0 : (ref7 = twin._source) === null || ref7 === void 0 ? void 0 : ref7.leadPlatform
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContainer/* TextContainer */.l, {
                                        className: "mt-2 text-sm leading-6",
                                        style: {
                                            color: "#551A8B"
                                        },
                                        children: twin === null || twin === void 0 ? void 0 : (ref8 = twin._source) === null || ref8 === void 0 ? void 0 : ref8.employeeTwinDescription
                                    })
                                ]
                            }),
                            showCloneBtn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/checkout/individual?empTwinId=".concat(twin === null || twin === void 0 ? void 0 : (ref9 = twin._source) === null || ref9 === void 0 ? void 0 : ref9.employeeTwinID, "&name=").concat(twin === null || twin === void 0 ? void 0 : (ref10 = twin._source) === null || ref10 === void 0 ? void 0 : ref10.employeeTwinName, "&image=").concat(twin === null || twin === void 0 ? void 0 : (ref11 = twin._source) === null || ref11 === void 0 ? void 0 : ref11.uploadPhoto),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "inline-block text-white bg-[#F05C52] px-14 py-2 text-sm font-medium rounded-full duration-500 hover:bg-opacity-50",
                                        children: "Clone"
                                    })
                                })
                            }) : null
                        ]
                    })
                })
            })
        }, twin === null || twin === void 0 ? void 0 : (ref12 = twin._source) === null || ref12 === void 0 ? void 0 : ref12.id)
    }) : null;
};
/* harmony default export */ var twinSlider_TwinCard = (TwinCard);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(15437);
;// CONCATENATED MODULE: ./components/layout/home/twinSlider/styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  .slick-track {\n    display: flex !important;\n  }\n\n  .slick-slide {\n    height: inherit !important;\n  }\n  .slick-slide {\n    margin-inline: 10px;\n  }\n\n  .nextArrow,\n  .prevArrow {\n    position: absolute;\n    top: 50%;\n    z-index: 10;\n  }\n\n  .prevArrow {\n    left: -5%;\n  }\n\n  .nextArrow {\n    right: -5%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Carousel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c6442434-0"
})(_templateObject());

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./components/layout/home/twinSlider/TwinBots.jsx



















var NextArrow = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: onClick,
        className: "nextArrow cursor-pointer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineArrowRight */.mGl, {
            className: "bg-main md:bg-[#508AC1] md:bg-opacity-50 text-white md:text-black h-8 w-8 rounded-full p-2"
        })
    });
};
var PrevArrow = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: onClick,
        className: "prevArrow cursor-pointer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineArrowLeft */.kyg, {
            className: "bg-main md:bg-[#508AC1] md:bg-opacity-50 text-white md:text-black h-8 w-8 rounded-full p-2"
        })
    });
};
var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    lazyLoad: "ondemand",
    nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextArrow, {}),
    prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevArrow, {}),
    responsive: [
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, 
    ]
};
var TwinBots = function(param) {
    var botId = param.botId, _headerName = param.headerName, headerName = _headerName === void 0 ? "Employee Twin" : _headerName, _showCloneBtn = param.showCloneBtn, showCloneBtn = _showCloneBtn === void 0 ? true : _showCloneBtn;
    var ref, ref1, ref2, ref3;
    //const { data, error, isLoading } = useSWR("elastic/searchQueryTwin", fetcher);
    var ref4 = (0,react.useState)(null), data = ref4[0], setData = ref4[1];
    var ref5 = (0,react.useState)(null), error = ref5[0], setError = ref5[1];
    var ref6 = (0,react.useState)(true), loading = ref6[0], setLoading = ref6[1];
    var fetchData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var authData, auth, response, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        authData = JSON.parse(localStorage.getItem("auth"));
                        if (!(authData && authData.data && authData.data.accessToken)) return [
                            3,
                            2
                        ];
                        auth = authData.data;
                        return [
                            4,
                            axios_default()({
                                method: "get",
                                url: "".concat(endpoints/* default.baseUrl */.ZP.baseUrl, "/elastic/searchQueryTwin"),
                                headers: {
                                    Authorization: auth.accessToken
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        data = response.data;
                        return [
                            2,
                            data
                        ];
                    case 2:
                        // Handle the case where 'auth.accessToken' is missing in 'localStorage'
                        console.error("Authentication data is missing or incomplete.");
                        _state.label = 3;
                    case 3:
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        // Handle any request errors here
                        console.error("Request error:", error);
                        throw error;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        fetchData().then(function(responseData) {
            setData(responseData);
        }).catch(function(error) {
            setError(error);
        }).finally(function() {
            setLoading(false);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "twinBots",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            className: "py-10 md:py-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-4xl text-center mb-12 text-main font-medium",
                    children: headerName
                }),
                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center my-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Loading..."
                    })
                }),
                error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center my-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Error fetching data. Please try again later."
                    })
                }),
                !loading && !error && (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.allTwinBots) === null || ref1 === void 0 ? void 0 : ref1.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                        children: data === null || data === void 0 ? void 0 : (ref2 = data.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.allTwinBots) === null || ref3 === void 0 ? void 0 : ref3.filter(function(item) {
                            return item._source.employeeTwinID !== botId;
                        }).map(function(twin, index) {
                            var ref;
                            return (twin === null || twin === void 0 ? void 0 : (ref = twin._source) === null || ref === void 0 ? void 0 : ref.employeeTwinName.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(twinSlider_TwinCard, {
                                twin: twin,
                                showCloneBtn: showCloneBtn
                            }, index) : null;
                        })
                    }))
                }) : null
            ]
        })
    });
};
/* harmony default export */ var twinSlider_TwinBots = (TwinBots);


/***/ }),

/***/ 21707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Container = function(param) {
    var children = param.children, className = param.className, _fullWidthOnMobile = param.fullWidthOnMobile, fullWidthOnMobile = _fullWidthOnMobile === void 0 ? false : _fullWidthOnMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(fullWidthOnMobile ? "w-full" : "px-[20px]", " md:px-[100px] ").concat(className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 65292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shared_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(15437);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./utility/endpoints.js
var endpoints = __webpack_require__(49530);
;// CONCATENATED MODULE: ./static/menuList.js





var menuList = function(order) {
    var ref = (0,react.useState)([]), skills = ref[0], setSkills = ref[1];
    var type = "";
    if (order === 1) {
        type = "Supply Chain";
    }
    if (order === 2) {
        type = "Finance";
    }
    if (order === 3) {
        type = "Marketing";
    }
    if (order === 4) {
        type = "HR Services";
    }
    var auth = JSON.parse(localStorage.getItem("auth")).data;
    var skillstat = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios_default()({
                                url: "".concat(endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/getETbyLeadPlatform"),
                                method: "POST",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    leadPlatform: type
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data.code === 200) {
                            // Filter soft skill data
                            setSkills(data);
                        } else {
                            console.log("No data found");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function skillstat(e) {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        skillstat();
    }, []);
    var supplyChain = [
        {
            label: skills.etname ? "Explore ".concat(skills.etname) : "Explore",
            list: skills && skills && skills.data ? skills.data.slice(0, 5).map(function(item) {
                return {
                    label: item.processName,
                    url: "".concat(endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin, "/botDetails?botID=").concat(window.btoa(item.id))
                };
            }) : []
        },
        {
            label: "Soft Skills",
            list: skills && skills && skills.softSkill ? skills.softSkill.map(function(item) {
                return {
                    label: item.processName,
                    url: "".concat(endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin, "/softskilldetails?softSkillID=").concat(item.botID)
                };
            }) : []
        }, 
    ];
    var finance = [
        {
            label: skills.etname ? "Explore ".concat(skills.etname) : "Explore",
            list: skills && skills && skills.data ? skills.data.slice(0, 5).map(function(item) {
                return {
                    label: item.processName,
                    url: "".concat(endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin, "/botDetails?botID=").concat(window.btoa(item.id))
                };
            }) : []
        },
        {
            label: "Soft Skills",
            list: skills && skills && skills.softSkill ? skills.softSkill.map(function(item) {
                return {
                    label: item.processName,
                    url: "".concat(endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin, "/softskilldetails?softSkillID=").concat(item.botID)
                };
            }) : []
        }, 
    ];
    var hr_services = [
        {
            label: skills.etname ? "Explore ".concat(skills.etname) : "Explore",
            list: skills && skills && skills.data ? skills.data.slice(0, 5).map(function(item) {
                return {
                    label: item.processName,
                    url: "".concat(endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin, "/botDetails?botID=").concat(window.btoa(item.id))
                };
            }) : []
        },
        {
            label: "Soft Skills",
            list: skills && skills && skills.softSkill ? skills.softSkill.map(function(item) {
                return {
                    label: item.processName,
                    url: "".concat(endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin, "/softskilldetails?softSkillID=").concat(item.botID)
                };
            }) : []
        }, 
    ];
    var marketing = [
        {
            label: skills.etname ? "Explore ".concat(skills.etname) : "Explore",
            list: skills && skills && skills.data ? skills.data.slice(0, 5).map(function(item) {
                return {
                    label: item.processName,
                    url: "".concat(endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin, "/botDetails?botID=").concat(window.btoa(item.id))
                };
            }) : []
        },
        {
            label: "Soft Skills",
            list: skills && skills && skills.softSkill ? skills.softSkill.map(function(item) {
                return {
                    label: item.processName,
                    url: "".concat(endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin, "/softskilldetails?softSkillID=").concat(item.botID)
                };
            }) : []
        }, 
    ];
    if (order === 1) {
        return supplyChain;
    }
    if (order === 2) {
        return finance;
    }
    if (order === 3) {
        return marketing;
    }
    if (order === 4) {
        return hr_services;
    }
};
var menuItems = [
    {
        label: "Supply Chain",
        href: "",
        key: 1
    },
    {
        label: "Finance",
        href: "",
        key: 2
    },
    {
        label: "Marketing",
        href: "",
        key: 3
    },
    {
        label: "HR Services",
        href: "",
        key: 4
    },
    {
        label: "HAP Products",
        href: "".concat(endpoints/* default.redirectUriLogin */.ZP.redirectUriLogin, "/products"),
        key: 5
    }, 
];

// EXTERNAL MODULE: ./components/shared/Container.jsx
var Container = __webpack_require__(21707);
;// CONCATENATED MODULE: ./components/shared/UserIcon.jsx

var UserIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "14",
            height: "16",
            viewBox: "0 0 14 16",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "7.2607",
                    cy: "4.60884",
                    r: "3.91304",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13.0327 13.4785C13.0327 13.8897 12.9895 14.1312 12.943 14.2631C12.9321 14.294 12.9225 14.315 12.9152 14.3287C12.8914 14.3303 12.8487 14.3299 12.7802 14.3197C12.6267 14.2966 12.4199 14.2353 12.1399 14.1285C11.9077 14.0399 11.657 13.9328 11.3728 13.8114C11.3169 13.7875 11.2597 13.7631 11.2012 13.7382C10.8521 13.5895 10.4651 13.4278 10.054 13.2795C9.23365 12.9837 8.28346 12.7285 7.261 12.7285C6.23853 12.7285 5.28834 12.9837 4.468 13.2795C4.05687 13.4278 3.66993 13.5895 3.32081 13.7382C3.26224 13.7631 3.20508 13.7875 3.14922 13.8114C2.86494 13.9328 2.61425 14.0399 2.38211 14.1285C2.1021 14.2353 1.89525 14.2966 1.74177 14.3197C1.67333 14.3299 1.63058 14.3303 1.60675 14.3287C1.59949 14.315 1.58993 14.294 1.57902 14.2631C1.53248 14.1312 1.48926 13.8897 1.48926 13.4785C1.48926 10.2909 4.07335 7.70679 7.261 7.70679C10.4486 7.70679 13.0327 10.2909 13.0327 13.4785ZM12.9008 14.351C12.9007 14.3509 12.9018 14.3494 12.9041 14.3471C12.902 14.35 12.9008 14.3512 12.9008 14.351ZM1.62123 14.351C1.62117 14.3512 1.61999 14.35 1.61785 14.3471C1.62022 14.3494 1.62129 14.3509 1.62123 14.351Z",
                    fill: "white",
                    stroke: "white",
                    strokeWidth: "1.5"
                })
            ]
        })
    });
};
/* harmony default export */ var shared_UserIcon = (UserIcon);

;// CONCATENATED MODULE: ./components/shared/Navbar/Logo.jsx

var Logo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "117",
            height: "43",
            viewBox: "0 0 117 43",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    id: "Group 3681",
                    children: [
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector",
                            d: "M10.7728 4.58057V7.80002H3.76375V11.6223H10.5726V14.7199H3.76375V18.5422H10.9959V21.7617H0V4.58057H10.7728Z",
                            fill: "#005DEE"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector_2",
                            d: "M33.881 10.0143C34.6598 10.8857 35.0492 12.0973 35.0492 13.6492V21.7618H31.3315V14.5365C31.3315 12.762 30.6026 11.8715 29.1448 11.8715C28.4592 11.8715 27.8301 12.091 27.261 12.533C26.6918 12.9719 26.3557 13.5061 26.2558 14.1294V21.7618H22.5381V14.5365C22.5381 12.762 21.8092 11.8715 20.3514 11.8715C19.8654 11.8715 19.3961 11.9892 18.9435 12.2182C18.4908 12.4471 18.128 12.7651 17.8518 13.1658C17.5755 13.5665 17.4357 13.999 17.4357 14.4633V21.7586H13.7446V8.99349H17.1595L17.3592 10.9843C17.8285 10.3292 18.4409 9.78535 19.1931 9.35285C19.9453 8.92035 20.8273 8.7041 21.8291 8.7041C22.831 8.7041 23.683 8.93625 24.3786 9.40055C25.0742 9.86485 25.5802 10.52 25.8997 11.3691C26.3357 10.6344 26.9547 10.0048 27.7569 9.48642C28.5623 8.96805 29.5142 8.70728 30.6192 8.70728C32.0105 8.70728 33.0922 9.14296 33.871 10.0143H33.881Z",
                            fill: "#005DEE"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector_3",
                            d: "M63.42 21.5663C62.2789 20.9767 61.3887 20.1565 60.7495 19.1058C60.1102 18.0551 59.7905 16.8727 59.7905 15.565C59.7905 14.2574 60.1102 13.0782 60.7495 12.0341C61.3887 10.99 62.2789 10.1731 63.42 9.58683C64.5611 8.99725 65.8672 8.7041 67.3382 8.7041C68.8092 8.7041 70.1394 8.99725 71.2804 9.58683C72.4215 10.1764 73.3117 10.99 73.951 12.0341C74.5903 13.0782 74.9099 14.2541 74.9099 15.565C74.9099 16.8759 74.5903 18.0551 73.951 19.1058C73.3117 20.1598 72.4215 20.98 71.2804 21.5663C70.1394 22.1559 68.823 22.449 67.3382 22.449C65.8534 22.449 64.5611 22.1559 63.42 21.5663ZM69.9709 18.1111C70.6377 17.4557 70.9711 16.6059 70.9711 15.5617C70.9711 14.5176 70.6377 13.6678 69.9709 13.0124C69.3042 12.3569 68.4346 12.0308 67.3657 12.0308C66.2968 12.0308 65.3997 12.3569 64.7329 13.0124C64.0662 13.6678 63.7328 14.5176 63.7328 15.5617C63.7328 16.6059 64.0662 17.4754 64.7329 18.121C65.3997 18.7666 66.2659 19.0894 67.3382 19.0894C68.4105 19.0894 69.3042 18.7633 69.9709 18.1078V18.1111Z",
                            fill: "#005DEE"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector_4",
                            d: "M87.9676 8.70737L82.3819 23.2877C81.8711 24.6215 81.213 25.6154 80.4043 26.2724C79.5955 26.9295 78.5347 27.2597 77.2152 27.2597C76.341 27.2597 75.5585 27.1192 74.8677 26.8413L75.2868 23.8075C75.6829 23.9383 76.0922 24.0037 76.5211 24.0037C77.1137 24.0037 77.618 23.8729 78.0272 23.6081C78.4398 23.3433 78.7672 22.902 79.016 22.2743L79.4351 21.2641L74.2227 8.7041H78.2008L81.3145 17.1908L84.2056 8.7041H87.961L87.9676 8.70737Z",
                            fill: "#005DEE"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector_5",
                            d: "M102.399 15.2546C102.399 13.9698 102.668 12.8315 103.203 11.8427C103.741 10.854 104.515 10.0831 105.527 9.53348C106.539 8.98056 107.73 8.7041 109.092 8.7041C110.454 8.7041 111.695 8.98707 112.758 9.55625C113.824 10.1254 114.654 10.932 115.25 11.9793C115.845 13.0266 116.144 14.2333 116.144 15.5993C116.144 17.0174 115.835 18.2371 115.213 19.2583C114.591 20.2796 113.689 21.0667 112.505 21.6196C111.322 22.1725 109.919 22.449 108.302 22.449C106.274 22.449 104.478 22.0945 102.911 21.3855L103.166 17.7785C103.849 18.0744 104.609 18.3086 105.453 18.4843C106.297 18.6599 107.101 18.7445 107.868 18.7445C108.873 18.7445 109.66 18.5883 110.232 18.2761C110.804 17.9639 111.174 17.4695 111.345 16.793H102.531C102.447 16.432 102.403 15.9213 102.403 15.2611L102.399 15.2546Z",
                            fill: "#00A889"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector_6",
                            d: "M112.021 14.1324C111.816 13.2526 111.467 12.5853 110.963 12.1404C110.446 11.6822 109.831 11.4531 109.112 11.4531C108.394 11.4531 107.823 11.7121 107.329 12.2333C106.835 12.7546 106.567 13.4119 106.523 14.2021H106.553C107.316 13.5912 108.283 13.226 109.334 13.226C110.385 13.226 111.275 13.568 112.021 14.1324Z",
                            fill: "white"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector_7",
                            d: "M101.581 16.793H92.7664C92.9379 17.4695 93.3079 17.9639 93.8796 18.2761C94.4513 18.5883 95.2383 18.7445 96.2438 18.7445C97.0106 18.7445 97.8144 18.6566 98.6585 18.4843C99.5027 18.3119 100.263 18.0777 100.945 17.7785L101.201 21.3855C99.6338 22.0945 97.8379 22.449 95.81 22.449C94.1923 22.449 92.7899 22.1725 91.6061 21.6196C90.4223 21.0667 89.5177 20.2796 88.8989 19.2583C88.2767 18.2371 87.9673 17.0174 87.9673 15.5993C87.9673 14.1812 88.2666 13.0266 88.8619 11.9793C89.4571 10.932 90.2878 10.1254 91.3539 9.55625C92.4166 8.98707 93.6408 8.7041 95.0197 8.7041C96.3985 8.7041 97.5722 8.98056 98.5845 9.53348C99.5968 10.0864 100.374 10.8572 100.908 11.8427C101.447 12.8315 101.712 13.9666 101.712 15.2546C101.712 15.9148 101.668 16.4254 101.584 16.7865L101.581 16.793Z",
                            fill: "#00D7C4"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector_8",
                            d: "M97.5888 12.1813C97.0187 11.7001 96.3422 11.4531 95.5524 11.4531C94.7042 11.4531 93.9761 11.6809 93.3649 12.1396C92.7536 12.5983 92.3312 13.2847 92.0908 14.2021H96.7886C96.5689 13.9872 96.4315 13.6953 96.4315 13.3745C96.4315 12.7522 96.9397 12.2454 97.5888 12.1813Z",
                            fill: "white"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector_9",
                            d: "M63.2233 28.4248H58.629V42.4121H54.8131V28.4248H50.1689V25.231H63.2266V28.4248H63.2233Z",
                            fill: "#005DEE"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector_10",
                            d: "M83.1533 29.3545L78.9544 42.4122H75.182L72.566 34.4117L70.0766 42.4122H66.3043L61.8521 29.3545H65.901L68.4904 37.9956L71.1064 29.3545H74.1756L76.8916 37.9469L79.3576 29.3545H83.1567H83.1533Z",
                            fill: "#005DEE"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector_11",
                            d: "M85.2074 27.3285C84.7566 26.9528 84.5312 26.4735 84.5312 25.8872C84.5312 25.301 84.7566 24.7957 85.2074 24.42C85.6582 24.0443 86.2323 23.8564 86.9225 23.8564C87.6128 23.8564 88.1903 24.0443 88.6517 24.42C89.113 24.7957 89.342 25.2848 89.342 25.8872C89.342 26.4897 89.113 26.9561 88.6517 27.3285C88.1903 27.7043 87.6163 27.8921 86.9225 27.8921C86.2287 27.8921 85.6617 27.7043 85.2074 27.3285ZM88.8877 29.4079V42.4121H84.982V29.4079H88.8877Z",
                            fill: "#005DEE"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector_12",
                            d: "M103.908 30.6647C104.733 31.5361 105.148 32.7477 105.148 34.2996V42.4122H101.43V35.1869C101.43 33.4124 100.645 32.5219 99.0757 32.5219C98.1971 32.5219 97.4359 32.789 96.7854 33.3265C96.1349 33.8639 95.8096 34.5063 95.8096 35.26V42.4122H92.0908V29.6439H95.5313L95.7325 31.6601C96.2388 30.9891 96.8894 30.4357 97.6807 30.0032C98.4721 29.5707 99.3943 29.3545 100.44 29.3545C101.926 29.3545 103.08 29.7902 103.908 30.6615V30.6647Z",
                            fill: "#005DEE"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector_13",
                            d: "M92.0908 6.12347C94.5326 3.58102 97.941 2 101.716 2C105.49 2 108.895 3.57675 111.334 6.1192",
                            stroke: "#005DEE",
                            "stroke-width": "2.5",
                            "stroke-miterlimit": "10",
                            "stroke-linecap": "round"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector_14",
                            d: "M53.605 4.58057V18.5373C53.605 21.1461 54.8394 22.4489 57.3115 22.4489C58.1974 22.4489 59.0237 22.275 59.7902 21.9305L59.4152 18.9573C58.9639 19.105 58.589 19.1805 58.287 19.1805C57.6201 19.1805 57.2849 18.7506 57.2849 17.8941V4.58057H53.605Z",
                            fill: "#005DEE"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector_15",
                            d: "M41.3917 20.9468C42.3379 21.7417 43.6015 22.1376 45.1827 22.1376C46.4691 22.1376 47.5902 21.8447 48.5461 21.2622C49.4987 20.6796 50.2374 19.8686 50.7591 18.8323C51.2808 17.796 51.5432 16.6149 51.5432 15.2857C51.5432 13.9565 51.3035 12.8687 50.8207 11.8742C50.3411 10.8797 49.6607 10.1009 48.7794 9.54088C47.898 8.98088 46.8806 8.7041 45.7239 8.7041C43.864 8.7041 42.3832 9.35099 41.2718 10.648L41.1487 8.97123H37.7983V26.5725H41.3917V20.9468ZM41.3917 14.5583C41.3917 14.0562 41.5375 13.5896 41.8324 13.1615C42.1272 12.7335 42.5258 12.3924 43.0313 12.1413C43.5367 11.8903 44.0908 11.7648 44.6935 11.7648C45.6882 11.7648 46.4626 12.0898 47.0167 12.7367C47.5708 13.3836 47.8494 14.2429 47.8494 15.3114C47.8494 16.4765 47.5513 17.4001 46.9584 18.0792C46.3622 18.7583 45.5424 19.0994 44.5023 19.0994C43.378 19.0994 42.3411 18.7905 41.3982 18.1758V14.5551L41.3917 14.5583Z",
                            fill: "#005DEE"
                        }),
                        " "
                    ]
                }),
                " "
            ]
        })
    });
};
/* harmony default export */ var Navbar_Logo = (Logo);

// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/shared/Navbar/MobileSubMenu.jsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  left: -100vw;\n  transition: all 0.4s ease-in;\n\n  &.active {\n    visibility: visible;\n    left: 0;\n    transition: all 0.5s ease-in;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var MobileSubMenu = function(param) {
    var show = param.show, closeMobileSubMenu = param.closeMobileSubMenu;
    var ref = (0,react.useState)(null), activeMenuItem = ref[0], setActiveMenuItem = ref[1];
    var subMenuItems = activeMenuItem && menuList(activeMenuItem);
    return show ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: "fixed top-0 w-full h-full overflow-hidden left-0 bg-white z-50 ".concat(show ? "active" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-accent py-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center pb-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Logo, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlineClose */.oHP, {
                                className: "h-8 w-8",
                                onClick: function() {
                                    return closeMobileSubMenu();
                                }
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-full overflow-y-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pb-6",
                    children: menuItems.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grid grid-cols-12 py-6 items-center  px-6 ".concat(index % 2 !== 0 ? "bg-main text-white" : "bg-gray-50"),
                                    onClick: function() {
                                        return !item.href.length && setActiveMenuItem(activeMenuItem === item.key ? null : item.key);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-span-8 font-medium text-xl",
                                            children: item.href.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: item.href,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: item.label
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: item.label
                                            })
                                        }),
                                        !item.href.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-span-4 ml-auto",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlineDown */.cuw, {
                                                className: "inline-block h-6 w-6"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(activeMenuItem === item.key ? "block" : "hidden"),
                                    children: subMenuItems && subMenuItems.map(function(subItem) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "px-6 mt-2 pb-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "mb-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "",
                                                        className: "text-lg font-medium text-main",
                                                        children: subItem.label
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "space-y-4 mt-4",
                                                    children: subItem.list.map(function(individualItem) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            className: "block",
                                                            href: individualItem.url,
                                                            target: "_blank",
                                                            children: individualItem.label
                                                        });
                                                    })
                                                })
                                            ]
                                        }, subItem.label);
                                    })
                                })
                            ]
                        }, item.key);
                    })
                })
            })
        ]
    }) : null;
};
/* harmony default export */ var Navbar_MobileSubMenu = (MobileSubMenu);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-325157d0-0"
})(_templateObject());

// EXTERNAL MODULE: ./node_modules/recharts/es6/component/ResponsiveContainer.js
var ResponsiveContainer = __webpack_require__(29009);
// EXTERNAL MODULE: ./node_modules/recharts/es6/chart/BarChart.js
var BarChart = __webpack_require__(94831);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/CartesianGrid.js
var CartesianGrid = __webpack_require__(14195);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/XAxis.js
var XAxis = __webpack_require__(3023);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/YAxis.js
var YAxis = __webpack_require__(75358);
// EXTERNAL MODULE: ./node_modules/recharts/es6/component/Tooltip.js + 3 modules
var Tooltip = __webpack_require__(26050);
// EXTERNAL MODULE: ./node_modules/recharts/es6/component/Legend.js + 1 modules
var Legend = __webpack_require__(33558);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/Bar.js + 2 modules
var Bar = __webpack_require__(30483);
;// CONCATENATED MODULE: ./static/pollQuestions.js
var pollQuestions = [
    {
        question: "Of the below 5 Soft Skills on an Employee Twin, the one I rate highest is:",
        options: [
            {
                label: "Currency Converter",
                value: "currency_converter"
            },
            {
                label: "Fun Facts",
                value: "fun_facts"
            },
            // { label: "Coin Toss", value: "coin_toss" },
            {
                label: "Dictionary",
                value: "dictionary"
            },
            {
                label: "World Clock",
                value: "world_clock"
            }, 
        ]
    },
    {
        question: "I’d love to see the below Skill added to the ET’s CV:",
        options: [
            {
                label: "Instant Natural Language Query results from 2 or more SAP Tables",
                value: "sap_tables"
            },
            {
                label: "Current status and YOY trend of KPIs listed for me/my function",
                value: "kpi_trend"
            },
            {
                label: "Timesheet Review of my T&M Vendors",
                value: "timesheet_review"
            },
            {
                label: "Questions you ask me to learn more and help better",
                value: "timesheet_review"
            }, 
        ]
    },
    {
        question: "What's your favorite BOT character from movies?",
        options: [
            {
                label: "TARS - Interstellar",
                value: "tars_interstellar"
            },
            {
                label: "CASE - Interstellar",
                value: "case_interstellar"
            },
            {
                label: "Android - Alien",
                value: "android_alien"
            },
            {
                label: "R2-D2 and C-3PO - Star Wars",
                value: "r2d2_c3po_starwars"
            }, 
        ]
    }, 
];

;// CONCATENATED MODULE: ./components/shared/Navbar/poll/style.js

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0%;\n  left: 0%;\n  height: 100vh;\n  width: 100vw;\n  z-index: 10;\n  backdrop-filter: blur(4px);\n  transition: all 0.3s ease-in;\n  visibility: hidden;\n  opacity: 0;\n  pointer-events: none;\n  background-color: rgba(0, 0, 0, 0.5);\n\n  &.active {\n    visibility: visible;\n    opacity: 1;\n    pointer-events: all;\n  }\n\n  .modal {\n    top: 25%;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: white;\n  }\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .recharts-legend-item-text {\n    display: none;\n  }\n\n  /* .recharts-surface {\n  display: none;\n} */\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var PollContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3136ab82-0"
})(style_templateObject());
var GraphContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3136ab82-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./components/shared/Navbar/poll/GraphScreen.jsx





var GraphScreen = function(param) {
    var showNextPoll = param.showNextPoll, closePoll = param.closePoll, currentPoll = param.currentPoll;
    var data = [
        {
            option: "a",
            percentage: 30
        },
        {
            option: "b",
            percentage: 20
        },
        {
            option: "c",
            percentage: 40
        },
        {
            option: "d",
            percentage: 10
        }, 
    ].sort(function(a, b) {
        return a - b;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GraphContainer, {
        className: "h-full w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute right-0 top-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlineClose */.oHP, {
                    className: "h-6 w-6 cursor-pointer bg-red-500 text-white p-1",
                    onClick: function() {
                        return closePoll();
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-52",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    width: "100%",
                    height: "100%",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: data,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartesianGrid/* CartesianGrid */.q, {
                                strokeDasharray: "3 3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                dataKey: "option"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "percentage",
                                fill: "#8884d8"
                            })
                        ]
                    })
                })
            }),
            currentPoll < pollQuestions.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-4 mx-auto text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "text-xs text-white px-6 py-2 rounded-full bg-main",
                    onClick: showNextPoll,
                    children: "Take another Poll"
                })
            })
        ]
    });
};
/* harmony default export */ var poll_GraphScreen = (GraphScreen);

;// CONCATENATED MODULE: ./components/shared/Navbar/poll/PollScreen.jsx



var PollScreen = function(param) {
    var currentOne = param.currentOne, setShowGraph = param.setShowGraph, closePoll = param.closePoll;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute right-0 top-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlineClose */.oHP, {
                    className: "h-6 w-6 cursor-pointer bg-red-500 text-white p-1",
                    onClick: function() {
                        return closePoll();
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                className: "text-lg font-medium",
                children: [
                    currentOne + 1,
                    ") ",
                    pollQuestions[currentOne].question,
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-2 gap-4 mt-6 w-11/12 mx-auto",
                children: pollQuestions[currentOne].options.map(function(param) {
                    var label = param.label, value = param.value;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "bg-[#005EEF] bg-opacity-5 text-center px-2 py-[10px] text-xs rounded-full font-medium text-[#7C868D] hover:text-white hover:bg-[#00A889] transition-all hover:bg-opacity-100 w-full",
                        onClick: function() {
                            setShowGraph(true);
                        },
                        children: label
                    }, value);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-end mt-8 text-sm",
                children: [
                    currentOne + 1,
                    "/",
                    pollQuestions.length
                ]
            })
        ]
    });
};
/* harmony default export */ var poll_PollScreen = (PollScreen);

;// CONCATENATED MODULE: ./components/shared/Navbar/Poll.jsx




//import { pollQuestions } from "../../../static/pollQuestions";





var Poll = function(param) {
    var show = param.show, closePoll = param.closePoll;
    var ref = (0,react.useState)(0), currentOne = ref[0], setCurrentOne = ref[1];
    var ref1 = (0,react.useState)(false), showGraph = ref1[0], setShowGraph = ref1[1];
    var ref2 = (0,react.useState)([]), pollQuestions = ref2[0], setpollQuestions = ref2[1];
    var skillstat = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(endpoints/* default.baseUrl */.ZP.baseUrl, "/poll/getQuiz"),
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data.code === 200) {
                            // Filter soft skill data
                            setpollQuestions(data.data);
                        } else {
                            console.log("No data found");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function skillstat(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var showNextPoll = function() {
        if (currentOne < pollQuestions.length - 1) {
            setShowGraph(false);
            setCurrentOne(function(prev) {
                return prev + 1;
            });
        }
    };
    (0,react.useEffect)(function() {
        setShowGraph(false);
        skillstat();
    }, [
        show
    ]);
    return show ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PollContainer, {
        className: "".concat(show ? "active" : "", " "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "absolute modal min-h-[320px] h-auto w-11/12 sm:w-[460px] flex flex-col items-center justify-center rounded-2xl px-6 border-t-4 border-[#00A889]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: showGraph ? /*#__PURE__*/ (0,jsx_runtime.jsx)(poll_GraphScreen, {
                    closePoll: closePoll,
                    currentPoll: currentOne,
                    showNextPoll: showNextPoll
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(poll_PollScreen, {
                    setShowGraph: setShowGraph,
                    currentOne: currentOne,
                    closePoll: closePoll
                })
            })
        })
    }) : null;
};
/* harmony default export */ var Navbar_Poll = (Poll);

// EXTERNAL MODULE: ./lib/utils.js
var utils = __webpack_require__(54601);
// EXTERNAL MODULE: ./components/elements/Loader.jsx
var Loader = __webpack_require__(85789);
;// CONCATENATED MODULE: ./components/shared/Navbar/description.js
var description = {
    "Supply Chain": "Employee Twins in Supply Chain automate tasks such as inventory management, demand forecasting, procurement, and logistics optimization to streamline operations, minimize waste, and reduce costs.",
    Finance: "Employee Twins in Finance focus on tasks such as financial reporting, budgeting, tax compliance, record-to-report processes, and treasury operations. They enhance accuracy and efficiency in fiscal management.",
    Marketing: "Employee Twins in Marketing support strategic campaigns, data analysis, customer insights generation, brand management, and promotion optimization, contributing to better alignment with consumer trends.",
    "HR Services": "For HR Services, Employee Twins assist in payroll processing, talent acquisition, onboarding, rewards management, compliance training, and skills development, providing smooth workflows and reducing administrative burden.",
    "HAP Products": "This category specializes in automating functions related to Health and Personal Care (HAP) product operations such as R&D, quality assurance processes, regulatory compliance, and market deployment strategies."
};
/* harmony default export */ var Navbar_description = (description);

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
;// CONCATENATED MODULE: ./components/shared/Navbar/SubMenu.jsx













var SubMenu = function(param) {
    var hoveredLink = param.hoveredLink, close = param.close;
    var menuData = menuList(hoveredLink);
    var ref = (0,utils/* getExploreAndCloneLink */.vE)(hoveredLink), cloneLink = ref.cloneLink, exploreLink = ref.exploreLink, type = ref.type;
    var noDataInLists = menuData.every(function(menu) {
        return menu.list.length === 0;
    });
    var ref1 = (0,react.useState)([]), skills = ref1[0], setSkills = ref1[1];
    var skillstat = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var auth, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = JSON.parse(localStorage.getItem("auth")).data;
                        return [
                            4,
                            axios_default()({
                                url: "".concat(endpoints/* default.baseUrl */.ZP.baseUrl, "/twin/getETbyLeadPlatform"),
                                method: "POST",
                                headers: {
                                    Authorization: "".concat(auth.accessToken, "|").concat(auth.email)
                                },
                                data: {
                                    leadPlatform: type
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data.code === 200) {
                            // Filter soft skill data
                            setSkills(data);
                        } else if (data.code === 403 || data.code === 401) {
                            react_toastify_esm/* toast.warn */.Am.warn("Session Expired");
                            window.location.reload();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function skillstat(e) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        skillstat();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onMouseLeave: function() {
            return close();
        },
        className: "absolute top-16 bg-white left-0 w-screen overflow-x-hidden subMenu ".concat(hoveredLink && "active"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            className: "pt-10 pb-16",
            children: noDataInLists ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center my-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-5 w-[60%]",
                        children: Navbar_description[type]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-2 gap-10",
                        children: menuData.map(function(menu, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    index === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/Employeetwinsdetail?empTwinId=".concat(skills.etid, "&name=").concat(skills.etname, "&leadPlatform=").concat(type),
                                        className: "",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "text-[#5A5A5A] mb-4 block",
                                            onClick: function() {
                                                return close();
                                            },
                                            children: menu.label
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "text-[#5A5A5A]  mb-4",
                                        children: menu.label
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "".concat(index === 0 ? "space-y-4" : "space-y-2"),
                                        children: menu.list.map(function(list) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    className: "",
                                                    href: (list === null || list === void 0 ? void 0 : list.url) || "#",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        className: " ".concat(index === 0 ? "text-xl font-medium" : "text-xs text-gray-500 font-medium", " hover:text-main transition-all"),
                                                        children: list.label
                                                    })
                                                })
                                            }, list.label);
                                        })
                                    })
                                ]
                            }, menu.label);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-7",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/checkout/individual?empTwinId=".concat(skills.etid, "&name=").concat(skills.etname, "&image=").concat(skills.etphoto),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                onClick: function() {
                                    return close();
                                },
                                className: "bg-red-500 text-white px-10 py-2 rounded-full",
                                children: "Clone"
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Navbar_SubMenu = (SubMenu);

;// CONCATENATED MODULE: ./components/shared/Navbar/Navbar.jsx

function Navbar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* position: relative; */\n\n  .subMenu {\n    transition: all 0.5s ease-in;\n    visibility: hidden;\n    opacity: 0;\n\n    &.active {\n      opacity: 1;\n      visibility: visible;\n      transition: all 0.5s ease-in;\n    }\n  }\n"
    ]);
    Navbar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Navbar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  .mainLink:not(:last-of-type) {\n    a {\n      span {\n        position: relative;\n\n        &::after {\n          content: "";\n          display: inline-block;\n           /* background-image: url("/images/logo.svg"); */\n          background-position: center;\n          background-size: contain;\n          background-repeat: no-repeat;\n          height: 20px;\n          width: 20px;\n          vertical-align: top;\n          margin-left: 3px;\n          visibility: hidden;\n          opacity: 0;\n\n          transition: all 0.5s ease-in;\n        }\n\n        &:hover::after {\n          visibility: visible;\n          opacity: 1;\n        }\n      }\n    }\n  }\n'
    ]);
    Navbar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var Navbar = function(param) {
    var handleNavbarSession = param.handleNavbarSession;
    var ref = (0,react.useState)(false), openMenu = ref[0], setOpenMenu = ref[1];
    var ref1 = (0,react.useState)(false), showPoll = ref1[0], setShowPoll = ref1[1];
    var ref2 = (0,react.useState)(null), hoveredLink = ref2[0], setHoveredLink = ref2[1];
    var ref3 = (0,react.useState)(false), showMobileMenu = ref3[0], setShowMobileMenu = ref3[1];
    var ref4 = (0,react.useState)(""), currentPathname = ref4[0], setCurrentPathname = ref4[1];
    var closePoll = function() {
        return setShowPoll(false);
    };
    // Handler when the mouse enters a link
    var handleLinkMouseEnter = function(label) {
        setHoveredLink(label);
        handleNavbarSession(label);
    };
    // Handler when the mouse leaves a link
    var handleLinkMouseLeave = function() {
        setHoveredLink(null);
    };
    var closeMobileSubMenu = function() {
        setShowMobileMenu(false);
    };
    var auth = "";
    if ( true && localStorage.getItem("auth")) {
        // Access localStorage here
        auth = JSON.parse(localStorage.getItem("auth")).data;
    }
    (0,react.useEffect)(function() {
        if (true) {
            setCurrentPathname(window.location.pathname);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Poll, {
                show: showPoll,
                closePoll: closePoll
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_MobileSubMenu, {
                show: showMobileMenu,
                closeMobileSubMenu: closeMobileSubMenu
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomNavBar, {
                className: "bg-accent sticky top-0 left-0 w-full z-30",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    className: "flex justify-between h-16 items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            className: "block",
                            href: "/newemployeetwin",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Logo, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden md:flex items-center gap-x-8",
                            children: menuItems.map(function(link, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
                                    className: "mainLink cursor-pointer ".concat(link.label === "HAP Products" ? "hover:text-blue-500 hover:underline" : ""),
                                    onMouseEnter: function() {
                                        if (index < menuItems.length - 1) {
                                            handleLinkMouseEnter(link.label);
                                        } else {
                                            handleLinkMouseLeave();
                                        }
                                    },
                                    children: [
                                        index === menuItems.length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            target: link.label === "HAP Products" ? "_blank" : null,
                                            className: "text-[13px] inline-block",
                                            href: link.href,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: link.label
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: link.label
                                        }),
                                        hoveredLink === link.label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_SubMenu, {
                                            hoveredLink: link.key,
                                            close: handleLinkMouseLeave
                                        })
                                    ]
                                }, link.label);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-x-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "bg-[#00a889] rounded-lg text-white font-medium px-2 py-1 text-xs",
                                        onClick: function() {
                                            setShowPoll(function(prev) {
                                                return !prev;
                                            });
                                            handleNavbarSession("Poll");
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlinePoll */.yfq, {
                                            className: "inline-block h-7 w-7 text-white"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "h-9 bg-[#005DEE] bg-opacity-10 rounded-full px-4 hidden md:flex items-center justify-center space-x-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                            className: "text-sm text-main font-medium",
                                            children: [
                                                "Hi, ",
                                                auth.name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-6 w-6 bg-main rounded-full p-1 flex items-center justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_UserIcon, {})
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Navbar_Navbar = (Navbar);
var List = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b71d3605-0"
})(Navbar_templateObject());
var CustomNavBar = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-b71d3605-1"
})(Navbar_templateObject1());

;// CONCATENATED MODULE: ./components/shared/Layout.jsx


var Layout = function(param) {
    var children = param.children, _showBar = param.showBar, showBar = _showBar === void 0 ? true : _showBar;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Navbar, {
                handleNavbarSession: function() {}
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                style: {
                    marginTop: "0px"
                },
                children: children
            })
        ]
    });
};
/* harmony default export */ var shared_Layout = (Layout);


/***/ }),

/***/ 16388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ TextContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15437);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 6;\n  line-clamp: 6;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var TextContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-43b487b7-0"
})(_templateObject());


/***/ }),

/***/ 29159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jr": function() { return /* binding */ LOCAL_STORAGE_KEY; }
/* harmony export */ });
/* unused harmony exports axiosConfig, fetcher */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);




var axiosConfig = function() {
    var customConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var defaultHeaders = {
        Authorization: Authorization,
        "Content-Type": "application/json"
    };
    var headers = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, defaultHeaders, customConfig.headers);
    // const baseURL = `https://automation-qa.unilever.com/api`;
    // const baseURL = process.env.NODE_ENV === "development" ? `/api` : "https://et-sandy.vercel.app/api/";
    var baseURL = (customConfig === null || customConfig === void 0 ? void 0 : customConfig.baseURL) ? customConfig.baseURL : "/api";
    return axios__WEBPACK_IMPORTED_MODULE_0___default().create({
        baseURL: baseURL,
        timeout: 5000,
        headers: headers
    });
};
var fetcher = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(url) {
        var axiosInstance, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    axiosInstance = axiosConfig();
                    return [
                        4,
                        axiosInstance.get(url)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function fetcher(url) {
        return _ref.apply(this, arguments);
    };
}();
//let auth = JSON.parse(localStorage.getItem("auth")).data;
// const Authorization = process.env.NEXT_PUBLIC_TOKEN;
var Authorization = "Bearer eyJ0eXAiOiJKV1QiLCJub25jZSI6InVONi1xZ1FPdXp6enhIRUdYdHQxeU1VZ2R2WjZmWjBHQlNPcVFUbEIxenMiLCJhbGciOiJSUzI1NiIsIng1dCI6Ii1LSTNROW5OUjdiUm9meG1lWm9YcWJIWkdldyIsImtpZCI6Ii1LSTNROW5OUjdiUm9meG1lWm9YcWJIWkdldyJ9.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.j0p3M2sIq_PieSnHIOIjyX6n9U72m4q7whSfV2FDVv20vJY1R-ahyxmabZxj3fADEFvTIg2yI7pvP3E_ATL7iM27Sfc8dYLf1X3oDcqwLcZd2ayE0wLoETXh8frWhuRIqOJY_B6-NRhZbsUFqCl-Uxq1HHM3Kzv1kbpb5pnbUACBjksLIjnVUpXYszjznifuZU9hQHYvuf7hsb-bgpRZHWat8JsH5jfAM-N1Pz6rdsvzi6EP2DrbcQCNzSbSRnTleiHp2iC3UJPXGWxl_SVaYTiHx-m_MZz6LVWjgzY0AzB1oR6XKv6K7CWTGo0dbbxCUVD--xMnjQmdBvTNsHYfTQ";
var LOCAL_STORAGE_KEY = "unilever-storage";


/***/ }),

/***/ 91345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useSas; }
/* harmony export */ });
/* unused harmony export useSasStore */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64529);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utility_endpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49530);





var inflight = null;
var useSasStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* .create */ .Ue)(function(set, get) {
    return {
        sasToken: "",
        sasUrl: "",
        loading: false,
        attempted: false,
        error: null,
        // Fetch Read-Only SAS Token
        fetchReadToken: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var sasToken;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                sasToken = get().sasToken;
                if (sasToken) return [
                    2,
                    sasToken
                ];
                if (inflight) return [
                    2,
                    inflight
                ]; // dedupe concurrent calls
                set({
                    loading: true,
                    error: null
                });
                inflight = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                    var res, data, err;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    4,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch("".concat(_utility_endpoints__WEBPACK_IMPORTED_MODULE_1__/* ["default"].baseUrl */ .ZP.baseUrl, "/sas/read"))
                                ];
                            case 1:
                                res = _state.sent();
                                if (!res.ok) throw new Error("HTTP ".concat(res.status));
                                return [
                                    4,
                                    res.json()
                                ];
                            case 2:
                                data = _state.sent();
                                if (!data.sasToken) throw new Error("Response missing sasToken");
                                set({
                                    sasToken: data.sasToken,
                                    sasUrl: data.sasUrl,
                                    loading: false,
                                    attempted: true
                                });
                                return [
                                    2,
                                    data.sasToken
                                ];
                            case 3:
                                err = _state.sent();
                                console.error("Failed to load read SAS token:", err);
                                set({
                                    error: err,
                                    loading: false,
                                    attempted: true
                                });
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                inflight = null;
                                return [
                                    7
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
                return [
                    2,
                    inflight
                ];
            });
        }),
        // Builds a blob URL with the current read SAS token
        getBlobUrl: function(blobPath) {
            if (!blobPath) return "";
            var ref = get(), sasToken = ref.sasToken, attempted = ref.attempted;
            // Trigger token fetch in background if missing (only once, never during render)
            if (!sasToken && !attempted && !inflight && "object" !== "undefined") {
                queueMicrotask(function() {
                    return get().fetchReadToken();
                });
            }
            // Full URL: strip any old query string and append current read SAS token
            if (blobPath.startsWith("http://") || blobPath.startsWith("https://")) {
                var baseUrl = blobPath.split("?")[0];
                return sasToken ? "".concat(baseUrl, "?").concat(sasToken) : baseUrl;
            }
            var accountName = "bnlwestgunileveraf01092" || 0;
            var containerName = "botstorevideo";
            var cleanPath = blobPath.startsWith("/") ? blobPath.slice(1) : blobPath;
            var encodedPath = cleanPath.split("/").map(function(part) {
                return encodeURIComponent(part);
            }).join("/");
            var baseUrl1 = "https://".concat(accountName, ".blob.core.windows.net/").concat(containerName, "/").concat(encodedPath);
            return sasToken ? "".concat(baseUrl1, "?").concat(sasToken) : baseUrl1;
        },
        // Request a short-lived full-access/admin token when needed
        fetchAdminToken: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var minutes, res, data, err;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        minutes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 15;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            fetch("".concat(_utility_endpoints__WEBPACK_IMPORTED_MODULE_1__/* ["default"].baseUrl */ .ZP.baseUrl, "/sas/admin?minutes=").concat(minutes))
                        ];
                    case 2:
                        res = _state.sent();
                        return [
                            4,
                            res.json()
                        ];
                    case 3:
                        data = _state.sent();
                        if (!res.ok) throw new Error(data.error || "Failed to fetch admin token");
                        return [
                            2,
                            data
                        ];
                    case 4:
                        err = _state.sent();
                        console.error("Error fetching short-lived admin SAS token:", err);
                        throw err;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })
    };
});
var useSas = function() {
    var sasToken = useSasStore(function(s) {
        return s.sasToken;
    });
    var sasUrl = useSasStore(function(s) {
        return s.sasUrl;
    });
    var loading = useSasStore(function(s) {
        return s.loading;
    });
    var error = useSasStore(function(s) {
        return s.error;
    });
    var attempted = useSasStore(function(s) {
        return s.attempted;
    });
    var fetchReadToken = useSasStore(function(s) {
        return s.fetchReadToken;
    });
    var getBlobUrl = useSasStore(function(s) {
        return s.getBlobUrl;
    });
    var fetchAdminToken = useSasStore(function(s) {
        return s.fetchAdminToken;
    });
    // Fetch once if missing when the hook is used
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!sasToken && !loading && !attempted) {
            fetchReadToken();
        }
    }, [
        sasToken,
        loading,
        attempted,
        fetchReadToken
    ]);
    return {
        sasToken: sasToken,
        sasUrl: sasUrl,
        loading: loading,
        error: error,
        getBlobUrl: getBlobUrl,
        fetchAdminToken: fetchAdminToken,
        fetchReadToken: fetchReadToken
    };
};


/***/ }),

/***/ 54601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B9": function() { return /* binding */ packages; },
/* harmony export */   "EZ": function() { return /* binding */ generateExcelAndDownload; },
/* harmony export */   "aE": function() { return /* binding */ generatePdfAndDownload; },
/* harmony export */   "q6": function() { return /* binding */ sortMonths; },
/* harmony export */   "vE": function() { return /* binding */ getExploreAndCloneLink; },
/* harmony export */   "w_": function() { return /* binding */ skillList; },
/* harmony export */   "wc": function() { return /* binding */ skillType; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var exceljs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74295);
/* harmony import */ var exceljs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(exceljs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93162);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(file_saver__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var html2canvas__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61120);
/* harmony import */ var html2canvas__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(html2canvas__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var jspdf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91819);






var packages = [
    {
        label: "Rookie",
        type: "rookie",
        soft: "10",
        functional: "",
        price: 0,
        icon: "/imagess/rookie.svg"
    }, 
];
var skillType = {
    all: "all",
    genAi: "Gen AI Skill",
    transactional: "transactionalSkill",
    reporting: "reportingSkills",
    cognitive: "cognitiveSkills",
    soft: "softSkill",
    decisionAutomation: "decisionAutomationSkills"
};
var skillList = [
    {
        key: "All",
        label: "All"
    },
    {
        label: "Gen AI",
        key: skillType.genAi
    },
    {
        label: "Transactional",
        key: skillType.transactional
    },
    {
        label: "Reporting",
        key: skillType.reporting
    },
    {
        label: "Cognitive",
        key: skillType.cognitive
    },
    {
        label: "Soft",
        key: skillType.soft
    },
    {
        label: "Decision",
        key: skillType.decisionAutomation
    }, 
];
var sortMonths = function() {
    var months = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    // Create an object to map month names to their numerical values
    var monthMap = {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12
    };
    // Custom sort function to sort the months array by their numerical values
    return months.sort(function(a, b) {
        return monthMap[a] - monthMap[b];
    });
};
var generateExcelAndDownload = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(filterData, fileName) {
        var workbook, worksheet, headerRow, buffer, blob;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    workbook = new exceljs__WEBPACK_IMPORTED_MODULE_0__.Workbook();
                    worksheet = workbook.addWorksheet("Data");
                    headerRow = worksheet.addRow(Object.keys(filterData[0]));
                    headerRow.font = {
                        bold: true
                    };
                    // Add data rows
                    filterData.forEach(function(item) {
                        var row = worksheet.addRow(Object.values(item));
                    });
                    return [
                        4,
                        workbook.xlsx.writeBuffer()
                    ];
                case 1:
                    buffer = _state.sent();
                    blob = new Blob([
                        buffer
                    ], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    });
                    (0,file_saver__WEBPACK_IMPORTED_MODULE_1__.saveAs)(blob, "".concat(fileName, ".xlsx"));
                    return [
                        2
                    ];
            }
        });
    });
    return function generateExcelAndDownload(filterData, fileName) {
        return _ref.apply(this, arguments);
    };
}();
var generatePdfAndDownload = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(element, name) {
        var pdf, content, canvas, imgData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pdf = new jspdf__WEBPACK_IMPORTED_MODULE_3__/* .jsPDF */ .kH();
                    content = document.getElementById(element);
                    return [
                        4,
                        html2canvas__WEBPACK_IMPORTED_MODULE_2___default()(content)
                    ];
                case 1:
                    canvas = _state.sent();
                    imgData = canvas.toDataURL("image/png");
                    pdf.addImage(imgData, "PNG", 10, 10, 190, 0);
                    pdf.save("".concat(name, ".pdf"));
                    return [
                        2
                    ];
            }
        });
    });
    return function generatePdfAndDownload(element, name) {
        return _ref.apply(this, arguments);
    };
}();
var getExploreAndCloneLink = function(hoveredLink) {
    var cloneLink;
    var exploreLink = "";
    var type;
    if (hoveredLink == 1) {
        //cloneLink = `/checkout/individual?empTwinId=ET00053&name=PRATIBIMB&image=/imagess/pratibimb.png`;
        // exploreLink = `/Employeetwinsdetail?empTwinId=ET00053&name=PRATIBIMB&leadPlatform=Supply Chain`;
        type = "Supply Chain";
    } else if (hoveredLink == 2) {
        //cloneLink = `/checkout/individual?empTwinId=ET00055&name=R2R Niyantran&image=https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/R2R%20logo.png`;
        //exploreLink = `/Employeetwinsdetail?empTwinId=ET00055&name=R2R Niyantran&leadPlatform=Finance`;
        type = "Finance";
    } else if (hoveredLink == 3) {
        //cloneLink = `/checkout/individual?empTwinId=ET00002&name=AAKAR&image=/imagess/aakar.png`;
        //exploreLink = `/Employeetwinsdetail?empTwinId=ET00002&name=AAKAR&leadPlatform=Marketing`;
        type = "Marketing";
    } else if (hoveredLink == 4) {
        //cloneLink = `/checkout/individual?empTwinId=ET00012&name=DEXTER&image=/imagess/dexter.png`;
        //exploreLink = `/Employeetwinsdetail?empTwinId=ET00012&name=DEXTER&leadPlatform=HR Services`;
        type = "HR Services";
    }
    return {
        cloneLink: cloneLink,
        exploreLink: exploreLink,
        type: type
    };
};


/***/ })

}]);